import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '@core/modules/svgIcons.module';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DropdownComponent } from './dropdown.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CypressDirectiveModule } from '../../../directives/cypress/cypress-directive.module';

@NgModule({
  declarations: [DropdownComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatChipsModule,
    MatIconModule,
    NgxMatSelectSearchModule,
    SvgIconModule,
    CypressDirectiveModule,
  ],
  exports: [DropdownComponent],
})
export class DropdownModule {}
